import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getFeatureFlag } from "@MasterBluePrint/Services/LaunchDarklyService";
import { getLaunchDarklySettings } from "@MasterBluePrint/Store/Context/ContextSelector";
import { LaunchDarklySettingsModel } from "@MasterBluePrint/Types/ApiModels";
import React, { FC, useEffect, useRef, useState } from "react";
import { css } from "styled-components";
import { connect } from "react-redux";

const enum fields {
    tariffMessagelabel = "tariffMessagelabel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.tariffMessagelabel]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const launchDarklySettings = getLaunchDarklySettings(state);
    return {
        launchDarklySettings
    };
};

type Props = OwnProps & WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

export interface ProductDetailsTariffMessageStyles {
    wrapper?: InjectableCss;
    verticalBarWrapper?: InjectableCss;
    verticalBar?: InjectableCss;
    messageText?: TypographyProps;
}

const tariffMessageStyles: ProductDetailsTariffMessageStyles = {
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
            background-color: #f5f7f9;
        `,
    },
    verticalBarWrapper: {
        css: css`
            margin-right: 0.25rem;
        `,
    },
    verticalBar: {
        css: css`
            width: 3px;
            height: 24px;
            background-color: #333F47;
        `,
    },
    messageText: {
        css: css`
            font-family: 'Lato', sans-serif;
            font-weight: 500;
            font-size: 12px;
            line-height: 1;
            letter-spacing: 0;
            color: #333F47;
            margin: 0;
        `,
    },
};

const styles = tariffMessageStyles;

const ProductDetailsTariffMessage: FC<Props> = ({ fields, product, launchDarklySettings }) => {

    const [isFeatureOn, setIsFeatureOn] = useState(false);
    const featureFlagKey = "TEUS-8330";

    useEffect(() => {
        checkFeatureFlag(launchDarklySettings, featureFlagKey);
    }, []);

    const checkFeatureFlag = async (launchDarklySettings: LaunchDarklySettingsModel, flagKey: string) => {
        const flagValue = await getFeatureFlag(launchDarklySettings, flagKey);
        setIsFeatureOn(flagValue);
    }

    if (!product) {
        return null;
    }

    return (
        <>
            {isFeatureOn && product.detail?.isSpecialOrder &&
                <StyledWrapper {...styles.wrapper}>
                    <StyledWrapper {...styles.verticalBarWrapper}>
                        <StyledWrapper {...styles.verticalBar} />
                    </StyledWrapper>
                    <Typography {...styles.messageText}>
                        {fields.tariffMessagelabel || translate("Price includes supplier surcharge due to tariffs.")}
                    </Typography>
                </StyledWrapper>
            }
        </>

    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsTariffMessage)),
    definition: {
        displayName: "Tariff Message",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.tariffMessagelabel,
                editorTemplate: "TextField",
                defaultValue: "Price includes supplier surcharge due to tariffs.",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;

